import { BaseContainerModel } from '../../base-container.model';
import { bl_fi_cash_stmt_hdr_RowClass, bl_fi_cash_stmt_ext_RowClass, bl_fi_cash_stmt_line_RowClass } from '../../../dbschema';

export class BankStatementContainerModel extends BaseContainerModel {
    bl_fi_cash_stmt_hdr: bl_fi_cash_stmt_hdr_RowClass = new bl_fi_cash_stmt_hdr_RowClass();
    bl_fi_cash_stmt_ext: bl_fi_cash_stmt_ext_RowClass[] = [];
    bl_fi_cash_stmt_line: bl_fi_cash_stmt_line_RowClass[] = [];
}